import { useEffect, useState } from "react";
import { db } from "../lib/firebase";
import { collection, onSnapshot, query, where, orderBy } from "firebase/firestore";

export function useCarts(env, client, startDate, endDate, instanceId) {
  const [loadedCarts, setLoadedCarts] = useState(false);
  const [carts, setCarts] = useState(null);

  useEffect(() => {
    setLoadedCarts(false);
    if (!client) {
      setLoadedCarts(true);
      return () => [];
    }

    let constraints = [];
    if (instanceId) {
      constraints.push(where("instance_id", "==", instanceId));
    }
    if (startDate) {
      constraints.push(where("created_at", ">=", startDate));
    }
    if (endDate) {
      constraints.push(where("created_at", "<=", endDate));
    }
    // Firestore requires the first orderBy to be on the same field as an inequality where clause
    constraints.push(orderBy("created_at", "desc"));

    const ref = collection(db, "kiosk", env, "client", client, "carts");
    const q = query(ref, ...constraints);

    const unsub = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCarts(data);
      setLoadedCarts(true);
    });

    return () => unsub();
  }, [env, client, startDate, endDate, instanceId]);

  return { loadedCarts, carts };
}
